export const getCookieType = (cookieType) => {
  if (cookieType == 'adform') return 'AdForm';
  if (cookieType == 'mobile') return 'Mobile';
  if (cookieType == 'ip') return 'Ip';
  if (cookieType == 'ar') return 'Audiencerate';
  if (cookieType == 'sirdata') return 'Sirdata';
  if (cookieType == 'weborama') return 'Weborama';
  if (cookieType == 'tdd') return 'TDD';
  if (cookieType == 'ID5') return 'ID5';

  return '';
};
